// import React, { useContext, useEffect, useState } from "react";
// import Box from "../../../setupPage/SharedComponents/Box";
// import SetupTittle from "../../../setupPage/SharedComponents/SetupTittle";
// import SetupContainer from "../../../setupPage/SharedComponents/SetupContainer";
// import GetLocalStorageUserId from "../../../sharedComponents/GetLocalStorageuserId";
// import axios from "axios";
// import Swal from "sweetalert2";
// import SetupInput from "../../../setupPage/SharedComponents/SetupInput";
// import SubmitBtn from "../../../setupPage/SharedComponents/SubmitBtn";
// import HistoryTable from "../../../setupPage/SharedComponents/HistoryTable";
// import SetupAutoComplete from "../../../setupPage/SharedComponents/SetupAutoComplete";
// import SetupTextArea from "../../../setupPage/SharedComponents/SetupTextArea";
// import { contextProvider } from "../../../setupPage/SetupPagesContextApi/SetupPagesContextApi";
// import { toast } from "react-toastify";
// import "./cashPayment.css"
// const CashPayment = () => {
//   const backendUrl = process.env.REACT_APP_API_URL;
//   const [fetchedData, setFetchedData] = useState([]);
//   const [refetch, setRefetch] = useState(false);
//   useEffect(() => {
//     axios
//       .get(`${backendUrl}Payment/GetAllPayments`)
//       .then((res) => setFetchedData(res.data))
//       .catch((err) => console.log(err.message));
//   }, [backendUrl, refetch]);

//   // input fields handle.
//   const initialValue = {
//     id: 1,
//     paymentMethodId: "",
//     paymentMethodName: "",
//     parcelOderNo: "",
//     orderAmount: "",
//     description: "",
//     paymentDate: "",
//     paymentInvoiceNo: "",
//     recordSerialNo: "", //
//     parcelNoWithRecordSerialNo: "",
//     creatorId: GetLocalStorageUserId(),
//     creationDate: new Date(),
//     modifierId: GetLocalStorageUserId(),
//     modificationDate: new Date(),
//   };

//   const [formData, setFormData] = useState(initialValue);
//   const [willUpdate, setWillUpdate] = useState(false);

//   console.log(formData,"this si sformdataaaaaaaaaaaaaaaaaaaaa.")
//   const update = (data) => {
//     setFormData({ ...formData, ...data });
//   };
//   const{handleDataReload}=useContext(contextProvider)
//   const formHandle = (e) => {
//     e.preventDefault();
//     formData.issueDate = new Date(formData.issueDate);
//     console.log(formData,"this si innnnnnnnnnnnnn.")
//     if (!willUpdate) {
//       axios
//         .post(`${backendUrl}Payment/CreatePayment`, { ...formData })

//         .then((res) => {
//           if(res.status===200) toast.error("Payment Already Completed For This Parcel Number.");
//           if (res.status === 201) {
//             Swal.fire({
//               title: `Cash Payment Created Successfully`,
//               icon: "success",
//             });
//             setRefetch((prev) => !prev);
//             setFormData(initialValue);
//             setWillUpdate(false);
//             handleDataReload()
//           }
//         })
//         .catch((err) => console.log(err));
//     }

//     if (willUpdate) {
//       console.log(formData);
//       axios
//         .put(`${backendUrl}Payment/CreatePayment/${formData.id}`, {
//           ...formData,
//         })

//         .then((res) => {
//           console.log(res,);
//           if (res.status === 204) {
//             Swal.fire({
//               title: `Additional Cost Updated Successfully`,
//               icon: "success",
//             });
//             setRefetch((prev) => !prev);
//             setFormData(initialValue);
//             setWillUpdate(false);
//             handleDataReload()
//           }
//         })
//         .catch((err) => console.log(err.message));
//     }
//   };

//   return (
//     <div>
//       <Box top>
//         <SetupTittle text="Payment" />
//         <SetupContainer>
//           <form className="" onSubmit={formHandle}>
//             <div className="grid lg:grid-cols-2 gap-y-4 grid-cols-1 lg:gap-y-[35px] lg:gap-x-[125px]">
//               <SetupInput
//                 type="date"
//                 placeHolder="Payment Date"
//                 name="IssueDate"
//                 allTimeValue={formData.paymentDate}
//                 valueUpdate={(e) => update({ paymentDate: e.target.value })}
//               />
//               <SetupAutoComplete
//                 dataOf="GetAllAdminParcel"
//                 valueUpdate={(_, value) => {
//                   console.log(value, "this si valieee");
//                   if (value?.parcelNo)
//                     axios
//                       .get(
//                         `${backendUrl}ParcelDetails/GetParcelDetailsByParcelNo/${value?.parcelNo}`
//                       )
//                       .then((res) => {
//                         console.log(
//                           res.data,

//                           "this is responsssssssssssse."
//                         );
//                         update({
//                           parcelOderNo: parseInt(value?.parcelNo),
//                           description: res.data?.description,
//                           orderAmount: res.data?.orderAmount,
//                           paymentMethodId: res.data?.paymentTypeMethodId,
//                           paymentMethodName:
//                             res.data?.paymentMethodName || "Not Available",
//                           parcelNoWithRecordSerialNo:
//                             value?.recordSerialNoWithParcelNo,
//                           recordSerialNo: value?.recordSerialNo||"",
//                           paymentInvoiceNo: "",
//                         });
//                       })
//                       .catch((err) => console.log(err));
//                   else
//                     update({
//                       parcelOderNo: "",
//                       description: "",
//                       orderAmount: "",
//                       paymentMethodId: "",
//                       paymentMethodName: "",
//                     });
//                 }}
//                 queryField="parcelNo"
//                 allTimeValue={parseInt(formData.parcelOderNo)}
//                 placeHolder="Parcel Number"
//               />
//               {/* <SetupAutoComplete
//                 dataOf="paymentMethod"
//                 valueUpdate={(_, value) => {
//                   console.log(value)
//                   update({ paymentMethodId:value?.id,paymentMethodName:value?.name })
//                 }}
//                 allTimeValue={formData.paymentMethodId}
//                 placeHolder="payment Method"
//               /> */}

//               <SetupInput
//                 disabled
//                 name="paymentMethod"
//                 type="text"
//                 placeHolder="payment Method"
//                 allTimeValue={formData.paymentMethodName}
//                 // valueUpdate={(e) =>
//                 //   update({ orderAmount: parseInt(e.target.value) })
//                 // }
//               />

//               <SetupInput
//                 disabled
//                 name="orderAmount"
//                 type="number"
//                 placeHolder="order Amount"
//                 allTimeValue={formData.orderAmount}
//                 valueUpdate={(e) =>
//                   update({ orderAmount: parseInt(e.target.value) })
//                 }
//               />

//               <SetupTextArea
//                 placeHolder="description"
//                 name="description"
//                 allTimeValue={formData.description}
//                 valueUpdate={(e) => update({ description: e.target.value })}
//               />
//               {formData?.paymentMethodName !== "Cash" && (
//                 <SetupInput
//                   name="paymentInvoiceNo"
//                   type="text"
//                   placeHolder="payment Invoice Number"
//                   allTimeValue={formData.paymentInvoiceNo}
//                   valueUpdate={(e) =>
//                     update({ paymentInvoiceNo: e.target.value })
//                   }
//                 />
//               )}
//             </div>
//             <SubmitBtn text={willUpdate ? "Update" : "Save"} />
//             <SubmitBtn
//               onClick={() => {
//                 setWillUpdate(false);
//                 update(initialValue);
//               }}
//               styleClass={!willUpdate && "hidden"}
//               text="Cancel"
//             />
//           </form>
//         </SetupContainer>
//       </Box>
//       <Box>
//         <SetupTittle text="History" />
//         <SetupContainer>
//           <div className="flex justify-end mb-4"></div>
//           <HistoryTable
//             // editCallBack={(data) => {
//             //   update(data);
//             //   setWillUpdate(true);
//             // }}
//             notEditAble
//             fetchedData={fetchedData}
//             headers={[
//               "payment Date",
//               "parcel order number",
//               // "record Serial Number",
//               // "payment Invoice No",
//               "order Amount",
//               "description",
//               "payment Method Name",
//             ]}
//             row={[
//               "paymentDate",
//               "parcelNoWithRecordSerialNo",
//               // "recordSerialNo",
//               // "",
//               "orderAmount",
//               "description",
//               "paymentMethodName",
//             ]}
//           />
//         </SetupContainer>
//       </Box>
//     </div>
//   );
// };

// export default CashPayment;

import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import Box from "../../../setupPage/SharedComponents/Box";
import SetupTittle from "../../../setupPage/SharedComponents/SetupTittle";
import SetupContainer from "../../../setupPage/SharedComponents/SetupContainer";
import GetLocalStorageUserId from "../../../sharedComponents/GetLocalStorageuserId";
import axios from "axios";
import Swal from "sweetalert2";
import SetupInput from "../../../setupPage/SharedComponents/SetupInput";
import HistoryTable from "../../../setupPage/SharedComponents/HistoryTable";
import SetupAutoComplete from "../../../setupPage/SharedComponents/SetupAutoComplete";
import SetupTextArea from "../../../setupPage/SharedComponents/SetupTextArea";
import { contextProvider } from "../../../setupPage/SetupPagesContextApi/SetupPagesContextApi";
import { toast } from "react-toastify";
import "./cashPayment.css";
import SetupDropDown from "../../../setupPage/SharedComponents/SetupDropdown";
import { openPaymentHistoryInvoice } from "../../../../utils/paymentHistoryInvoice";

function normalizePaymentStatus(payment) {
  const id = Number(payment?.paymentStatusId);
  const name = String(payment?.statusName || "")
    .trim()
    .toLowerCase();

  if (id === 2 || name === "paid" || name.includes("complete")) {
    return "paid";
  }
  if (
    id === 1 ||
    name.includes("pending") ||
    name.includes("unpaid") ||
    name === "due"
  ) {
    return "unpaid";
  }
  return "other";
}

const STATUS_FILTERS = [
  { value: "all", label: "All" },
  { value: "paid", label: "Paid" },
  { value: "unpaid", label: "Unpaid" },
];

const CashPayment = () => {
  const backendUrl = process.env.REACT_APP_API_URL;
  const [fetchedData, setFetchedData] = useState([]);
  const [refetch, setRefetch] = useState(false);
  const [invoiceBusyKey, setInvoiceBusyKey] = useState(null);
  const [statusFilter, setStatusFilter] = useState("all");

  // Fetch payment data
  useEffect(() => {
    axios
      .get(`${backendUrl}Payment/GetAllPayments`)
      .then((res) => setFetchedData(res.data))
      .catch((err) => {
        console.log(err.message);
        toast.error("Failed to load payment history");
      });
  }, [backendUrl, refetch]);

  const filteredPayments = useMemo(() => {
    const rows = Array.isArray(fetchedData) ? fetchedData : [];
    if (statusFilter === "all") return rows;
    return rows.filter(
      (payment) => normalizePaymentStatus(payment) === statusFilter,
    );
  }, [fetchedData, statusFilter]);

  // Initial form values
  const initialValue = {
    id: 1,
    paymentMethodId: "",
    paymentMethodName: "",
    parcelOderNo: "",
    orderAmount: "",
    description: "",
    paymentDate: "",
    paymentInvoiceNo: "",
    recordSerialNo: "",
    parcelNoWithRecordSerialNo: "",
    PaymentStatusId: 0,
    creatorId: GetLocalStorageUserId(),
    creationDate: new Date(),
    modifierId: GetLocalStorageUserId(),
    modificationDate: new Date(),
    currencyTypeId: 0,
    stripePaymentIntentId: "",
    stripeChargeId: "",
    cardLast4: "",
    cardBrand: "",
    stripePaymentMethod: "",
  };

  const [formData, setFormData] = useState(initialValue);
  const [willUpdate, setWillUpdate] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);

  const update = (data) => {
    setFormData((prev) => ({ ...prev, ...data }));
  };

  const { handleDataReload } = useContext(contextProvider);

  const closePaymentModal = () => {
    setShowPaymentModal(false);
    setWillUpdate(false);
    setFormData({
      ...initialValue,
      paymentDate: new Date().toISOString().split("T")[0],
    });
  };

  const openCreatePaymentModal = () => {
    setWillUpdate(false);
    setFormData({
      ...initialValue,
      paymentDate: new Date().toISOString().split("T")[0],
    });
    setShowPaymentModal(true);
  };

  const formHandle = (e) => {
    e.preventDefault();
    formData.paymentDate = new Date(formData.paymentDate);

    if (!willUpdate) {
      axios
        .post(`${backendUrl}Payment/CreatePayment`, { ...formData })
        .then((res) => {
          if (res.status === 200) {
            toast.error("Payment Already Completed For This Parcel Number.");
          }
          if (res.status === 201) {
            Swal.fire({
              title: `Cash Payment Created Successfully`,
              icon: "success",
            });
            setRefetch((prev) => !prev);
            closePaymentModal();
            handleDataReload();
          }
        })
        .catch((err) => {
          console.log(err);
          toast.error("Failed to create payment");
        });
    } else {
      axios
        .put(`${backendUrl}Payment/UpdatePayment/${formData.id}`, {
          ...formData,
          PaymentStatusId: parseInt(formData.PaymentStatusId),
        })
        .then((res) => {
          if (res.status === 204) {
            Swal.fire({
              title: `Payment Updated Successfully`,
              icon: "success",
            });
            setRefetch((prev) => !prev);
            closePaymentModal();
            handleDataReload();
          }
        })
        .catch((err) => {
          console.log(err.message);
          toast.error("Failed to update payment");
        });
    }
  };

  useEffect(() => {
    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0];
    setFormData((prev) => ({
      ...prev,
      paymentDate: formattedDate,
    }));
  }, []);

  const resolveParcelNumber = (historyData) => {
    if (historyData?.parcelOderNo) return historyData.parcelOderNo;
    const serial = historyData?.parcelNoWithRecordSerialNo;
    if (!serial) return null;
    if (String(serial).includes("~")) return String(serial).split("~")[0];
    const match = String(serial).match(/^(\d+)/);
    return match ? match[1] : serial;
  };

  const handleInvoiceAction = useCallback(async (payment, mode) => {
    const invoiceNo = String(payment?.paymentInvoiceNo || "").trim();
    const canInvoice = /^inv/i.test(invoiceNo) || invoiceNo.length >= 6;
    if (!canInvoice) {
      toast.error("This payment has no printable invoice number.");
      return;
    }
    const key = payment?.id ?? invoiceNo;
    setInvoiceBusyKey(key);
    try {
      await openPaymentHistoryInvoice(payment, mode);
    } catch (err) {
      toast.error(
        err?.response?.data?.message ||
          err?.message ||
          "Failed to open invoice.",
      );
    } finally {
      setInvoiceBusyKey(null);
    }
  }, []);

  return (
    <div>
      <Box top>
        <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
          <SetupTittle text="Payment History" />
          <div className="flex flex-wrap items-center gap-3">
            <div
              className="payment-status-filter"
              role="group"
              aria-label="Filter by payment status"
            >
              {STATUS_FILTERS.map((opt) => (
                <button
                  key={opt.value}
                  type="button"
                  className={`payment-status-filter__btn${
                    statusFilter === opt.value
                      ? " payment-status-filter__btn--active"
                      : ""
                  }`}
                  onClick={() => setStatusFilter(opt.value)}
                >
                  {opt.label}
                </button>
              ))}
            </div>
            <button
              type="button"
              onClick={openCreatePaymentModal}
              className="font-medium text-sm rounded-xl h-10 px-4 text-white bg-stone-900 hover:bg-stone-800"
            >
              Add Payment
            </button>
          </div>
        </div>
        <SetupContainer>
          <HistoryTable
            groupBy="parcelNoWithRecordSerialNo"
            invoiceBusyKey={invoiceBusyKey}
            onPrintInvoice={(payment) => handleInvoiceAction(payment, "print")}
            onDownloadInvoice={(payment) =>
              handleInvoiceAction(payment, "download")
            }
            editCallBack={async (historyData) => {
              try {
                const parcelNumber = resolveParcelNumber(historyData);

                if (!parcelNumber) {
                  toast.error("Could not determine parcel number");
                  return;
                }

                const parcelResponse = await axios.get(
                  `${backendUrl}ParcelDetails/GetParcelDetailsByParcelNo/${parcelNumber}`,
                );
                const parcelData = parcelResponse.data;

                const formReadyData = {
                  id: historyData.id || 0,
                  paymentMethodId:
                    parcelData.paymentTypeMethodId ||
                    historyData.paymentMethodId ||
                    "",
                  paymentMethodName:
                    parcelData.paymentMethodName ||
                    historyData.paymentMethodName ||
                    "",
                  parcelOderNo: parcelNumber,
                  orderAmount:
                    historyData.orderAmount ||
                    parcelData.orderAmount ||
                    0,
                  description:
                    historyData.description || parcelData.description || "",
                  paymentDate:
                    historyData.paymentDate?.split("T")[0] ||
                    new Date().toISOString().split("T")[0],
                  paymentInvoiceNo: historyData.paymentInvoiceNo || "",
                  recordSerialNo:
                    parcelData.recordSerialNo ||
                    historyData.recordSerialNo ||
                    "",
                  parcelNoWithRecordSerialNo:
                    parcelData.recordSerialNoWithParcelNo ||
                    historyData.parcelNoWithRecordSerialNo ||
                    "",
                  PaymentStatusId:
                    historyData.paymentStatusId ||
                    parcelData.paymentStatusId ||
                    0,
                  creatorId: historyData.creatorId || GetLocalStorageUserId(),
                  creationDate: historyData.creationDate || new Date(),
                  modifierId: historyData.modifierId || GetLocalStorageUserId(),
                  modificationDate: historyData.modificationDate || new Date(),
                  currencyTypeId:
                    historyData.currencyTypeId ||
                    parcelData.currencyTypeId ||
                    0,
                };

                update(formReadyData);
                setWillUpdate(true);
                setShowPaymentModal(true);
              } catch (error) {
                console.error("Error loading parcel details:", error);
                toast.error("Failed to load complete parcel data");
              }
            }}
            fetchedData={filteredPayments}
            headers={[
              "Payment Date",
              "Parcel Order Number",
              "Order Amount",
              "Currency Type",
              "Description",
              "Payment Method",
              "Payment Status",
            ]}
            row={[
              "paymentDate",
              "parcelNoWithRecordSerialNo",
              "orderAmount",
              "currencyType",
              "description",
              "paymentMethodName",
              "statusName",
            ]}
            extraFields={[
              "paymentStatusId",
              "currencyTypeId",
              "parcelOderNo",
              "paymentInvoiceNo",
              "paymentMethodId",
              "symbol",
            ]}
          />
        </SetupContainer>
      </Box>

      {showPaymentModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-3 sm:px-4 py-4"
          onClick={closePaymentModal}
          role="presentation"
        >
          <div
            className="payment-modal bg-white w-full max-h-[90vh] overflow-y-auto overflow-x-hidden rounded-2xl border border-stone-200 shadow-xl p-4 sm:p-6 relative min-w-0"
            role="dialog"
            aria-modal="true"
            aria-labelledby="payment-modal-title"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              onClick={closePaymentModal}
              className="absolute top-3 right-3 text-gray-500 hover:text-gray-800 text-2xl font-bold leading-none z-10"
              aria-label="Close payment form"
            >
              &times;
            </button>

            <h2
              id="payment-modal-title"
              className="text-xl sm:text-2xl font-bold text-stone-900 mb-5 pr-8 break-words"
            >
              {willUpdate ? "Update Payment" : "Payment"}
            </h2>

            <form onSubmit={formHandle} className="min-w-0">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-x-8 md:gap-y-6 min-w-0">
                <div className="payment-modal-field">
                  <SetupInput
                    type="date"
                    placeHolder="Payment Date"
                    name="paymentDate"
                    allTimeValue={formData.paymentDate}
                    valueUpdate={(e) => update({ paymentDate: e.target.value })}
                    required
                  />
                </div>

                <div className="payment-modal-field">
                  <SetupAutoComplete
                    dataOf="GetAllAdminParcel"
                    valueUpdate={(_, value) => {
                      if (value?.parcelNo) {
                        axios
                          .get(
                            `${backendUrl}ParcelDetails/GetParcelDetailsByParcelNo/${value?.parcelNo}`,
                          )
                          .then((res) => {
                            update({
                              id: res.data?.paymentId || 0,
                              parcelOderNo: parseInt(value?.parcelNo),
                              description: res.data?.description,
                              orderAmount: res.data?.orderAmount,
                              paymentMethodId: res.data?.paymentTypeMethodId,
                              paymentMethodName:
                                res.data?.paymentMethodName || "Not Available",
                              parcelNoWithRecordSerialNo:
                                value?.recordSerialNoWithParcelNo,
                              recordSerialNo: value?.recordSerialNo || "",
                              paymentInvoiceNo: "",
                              PaymentStatusId: res.data?.paymentStatusId || 0,
                            });

                            if (
                              res.data?.paymentStatusId == 1 ||
                              res.data?.paymentStatusId == null ||
                              res.data?.paymentStatusId == 3
                            ) {
                              setWillUpdate(true);
                            }
                          })
                          .catch((err) => console.log(err));
                      } else {
                        update({
                          id: 0,
                          parcelOderNo: "",
                          description: "",
                          orderAmount: "",
                          paymentMethodId: "",
                          paymentMethodName: "",
                          PaymentStatusId: 0,
                        });
                        setWillUpdate(false);
                      }
                    }}
                    queryField="parcelNo"
                    allTimeValue={parseInt(formData.parcelOderNo)}
                    placeHolder="Parcel Number"
                    required
                  />
                </div>

                <div className="payment-modal-field">
                  <SetupInput
                    disabled
                    name="paymentMethod"
                    type="text"
                    placeHolder="Payment Method"
                    allTimeValue={formData.paymentMethodName}
                  />
                </div>

                <div className="payment-modal-field">
                  <SetupInput
                    disabled
                    name="orderAmount"
                    type="number"
                    placeHolder="Order Amount"
                    allTimeValue={formData.orderAmount}
                  />
                </div>

                <div className="payment-modal-field">
                  <SetupDropDown
                    dataOf={"currency"}
                    allTimeValue={formData.currencyTypeId}
                    valueUpdate={(e) =>
                      update({ currencyTypeId: e.target?.value })
                    }
                    placeHolder="Currency Type"
                    name="id"
                  ></SetupDropDown>
                </div>

                <div className="payment-modal-field md:row-span-2">
                  <SetupTextArea
                    placeHolder="Description"
                    name="description"
                    allTimeValue={formData.description}
                    valueUpdate={(e) => update({ description: e.target.value })}
                  />
                </div>

                <div className="payment-modal-field">
                  <SetupDropDown
                    dataOf={"PaymentStatus"}
                    allTimeValue={formData.PaymentStatusId}
                    valueUpdate={(e) =>
                      update({ PaymentStatusId: e.target?.value })
                    }
                    placeHolder="Payment Status"
                    name="id"
                  />
                </div>

                {formData?.paymentMethodName !== "Cash" && (
                  <div className="payment-modal-field">
                    <SetupInput
                      name="paymentInvoiceNo"
                      type="text"
                      placeHolder="Payment Invoice Number"
                      allTimeValue={formData.paymentInvoiceNo}
                      valueUpdate={(e) =>
                        update({ paymentInvoiceNo: e.target.value })
                      }
                    />
                  </div>
                )}
              </div>

              <div className="flex flex-wrap items-center gap-3 mt-6">
                <button
                  type="submit"
                  className="inline-flex items-center justify-center font-medium text-sm rounded-xl h-10 px-4 text-white bg-stone-900 hover:bg-stone-800"
                >
                  {willUpdate ? "Update" : "Save"}
                </button>
                <button
                  type="button"
                  onClick={closePaymentModal}
                  className="inline-flex items-center justify-center font-medium text-sm rounded-xl h-10 px-4 border border-stone-200 text-stone-700 bg-white hover:bg-stone-50"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default CashPayment;
